// components/calendar/agendaCalendar.constants.js
import React from 'react';
import {
    DirectionsBus as DirectionsBusIcon,
    CheckCircle as CheckCircleIcon,
    Pending as PendingIcon,
    Cancel as CancelIcon,
    Timeline as TimelineIcon,
} from '@mui/icons-material';
import { parseISO } from 'date-fns';

export const ESTADO_CONFIG = {
    CREADO: { label: 'CREADO', bg: '#f5f5f5', color: '#424242', border: '#9e9e9e', icon: <PendingIcon fontSize="small" /> },
    PLANIFICADO: { label: 'PLANIFICADO', bg: '#fff8e1', color: '#6d4c00', border: '#f9a825', icon: <TimelineIcon fontSize="small" /> },
    EN_PROCESO: { label: 'EN PROCESO', bg: '#e8f5e9', color: '#1b5e20', border: '#43a047', icon: <DirectionsBusIcon fontSize="small" /> },
    COMPLETADO: { label: 'COMPLETADO', bg: '#e3f2fd', color: '#0d47a1', border: '#1e88e5', icon: <CheckCircleIcon fontSize="small" /> },
    CANCELADO: { label: 'CANCELADO', bg: '#ffebee', color: '#b71c1c', border: '#e53935', icon: <CancelIcon fontSize="small" /> },
};

export const getEstadoConfig = (estado) =>
    ESTADO_CONFIG[estado] || {
        label: estado || 'SIN ESTADO',
        bg: '#eeeeee',
        color: '#424242',
        border: '#757575',
        icon: <PendingIcon fontSize="small" />,
    };

export const CALENDAR_MESSAGES = {
    allDay: 'Todo el día',
    previous: 'Anterior',
    next: 'Siguiente',
    today: 'Hoy',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'No hay manifiestos en este rango.',
    showMore: (total) => `+ ${total} más`,
};

export const parseSafeDate = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) return value;
    if (typeof value === 'string') {
        const parsed = parseISO(value);
        return !isNaN(parsed.getTime()) ? parsed : null;
    }
    return null;
};

export const getManifestCode = (manid) => `MN-${String(manid || '').padStart(6, '0')}`;

export const formatDuration = (minutes) => {
    if (!minutes) return null;
    if (minutes < 60) return `${minutes} min`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m > 0 ? `${h}h ${m}min` : `${h}h`;
};

export const STORAGE_KEYS = {
    CALENDAR_VIEW: 'agenda_calendar_view',
    ESTADO_FILTER: 'agenda_estado_filter',
};